import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  metsSection: {},
  metsList: {
    padding: 0,
  },
  metItem: {
    padding: theme.spacing(1, 0),
    alignItems: 'flex-start',
  },
  metIcon: {
    minWidth: 36,
    marginTop: theme.spacing(1),
  },
  checkIcon: {
    color: theme.palette.success.main,
  },
  xIcon: {
    color: theme.palette.error.main,
  },
  metPrimary: {
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
  metSecondary: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5),
  },
  copyHighlight: {
    cursor: 'pointer',
    width: 'fit-content',
  },
}))

export default styles
